import React, { Component } from 'react'
import { NavLink, Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { logout } from 'store/actions/authAction'

import {toggleMenu} from '../store/actions/menuAction'
import {toggleSettings} from '../store/actions/settingsAction'
import Icon from 'ui/Icon'

class Nav extends Component{

  logout(){
    this.props.history.push('/')
    this.props.dispatch(logout())
  }

  openMenu(){
    this.props.dispatch(toggleSettings(false))
    this.props.dispatch(toggleMenu(true))
  }

  openSettings(){
    this.props.dispatch(toggleMenu(false))
    this.props.dispatch(toggleSettings(true))
  }

  render(){
    return (
      <div className="nav">
        <div className="nav-left">
          <Icon name="menu-outline" action={() => this.openMenu()}/>
        </div>
        <div className="nav-right">
          <Icon name="settings" action={() => this.openSettings()}/>
          <div className="version">v{process.env.REACT_APP_VERSION}</div>
        </div>
      </div>
    )
  }
}
export default withRouter(connect()(Nav))



// WEBPACK FOOTER //
// ./src/components/Nav.js